/* PUVANO Warenkorb – reine Logik ohne DOM. Tests: tests/cart-drawer-logic.test.ts */
(function (root) {
  'use strict';

  function computeRewards(count, tiers) {
    var sorted = (tiers || [])
      .filter(function (t) { return Number(t.count) > 0; })
      .map(function (t) { return { count: Number(t.count), message: t.message || '', label: t.label || '' }; })
      .sort(function (a, b) { return a.count - b.count; });
    var prev = 0, fills = [], completed = [];
    sorted.forEach(function (t) {
      var span = t.count - prev;
      var f = span <= 0 ? (count >= t.count ? 1 : 0) : (count - prev) / span;
      f = Math.max(0, Math.min(1, f));
      fills.push(Math.round(f * 10000) / 100);
      completed.push(count >= t.count);
      prev = t.count;
    });
    var nextIndex = -1;
    for (var i = 0; i < sorted.length; i++) {
      if (count < sorted[i].count) { nextIndex = i; break; }
    }
    return {
      tiers: sorted,
      fills: fills,
      completed: completed,
      nextIndex: nextIndex,
      remaining: nextIndex === -1 ? 0 : sorted[nextIndex].count - count
    };
  }

  function rewardsMessage(result, maxText) {
    if (result.nextIndex === -1) return maxText || '';
    return result.tiers[result.nextIndex].message.replace(/\{count\}/g, String(result.remaining));
  }

  function mergeRecommendations(lists, excludeProductIds, limit) {
    var seen = {};
    (excludeProductIds || []).forEach(function (id) { seen[String(id)] = true; });
    var out = [];
    (lists || []).forEach(function (list) {
      (list || []).forEach(function (product) {
        var id = String(product.id);
        if (seen[id] || product.available === false) return;
        seen[id] = true;
        out.push(product);
      });
    });
    return limit > 0 ? out.slice(0, limit) : out;
  }

  function optionNames(product) {
    return (product.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
  }

  function pickVariant(product, cartItems, smart) {
    var variants = product.variants || [];
    if (!variants.length) return null;
    var available = variants.filter(function (v) { return v.available; });
    var pool = available.length ? available : variants;
    if (!smart) return pool[0];
    var names = optionNames(product);
    var wanted = {};
    (cartItems || []).forEach(function (item) {
      (item.options_with_values || []).forEach(function (o) { wanted[o.name + '\u0000' + o.value] = true; });
    });
    var best = pool[0], bestScore = 0;
    pool.forEach(function (v) {
      var values = v.options || [v.option1, v.option2, v.option3];
      var score = 0;
      values.forEach(function (value, i) {
        if (value != null && names[i] && wanted[names[i] + '\u0000' + value]) score++;
      });
      if (score > bestScore) { best = v; bestScore = score; }
    });
    return best;
  }

  function groupDiscounts(cart) {
    var titles = [];
    function add(title) { if (title && titles.indexOf(title) === -1) titles.push(title); }
    // /cart.js liefert {title}, /cart/change.js liefert {amount, discount_application: {title}}
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      add(a.title || (a.discount_application && a.discount_application.title));
    });
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (a) {
        add(a.discount_application && a.discount_application.title);
      });
    });
    return { titles: titles, total: Number(cart.total_discount) || 0 };
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || '{{amount}}';
    function fmt(precision, thousands, decimal) {
      var parts = (cents / 100).toFixed(precision).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    var match = /\{\{\s*(\w+)\s*\}\}/.exec(format);
    var value;
    switch (match && match[1]) {
      case 'amount_no_decimals': value = fmt(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmt(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(2, ' ', ','); break;
      default: value = fmt(2, ',', '.');
    }
    return match ? format.replace(match[0], value) : value;
  }

  var ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ESC[c]; });
  }

  function sizedImage(url, width) {
    if (!url) return '';
    var u = url.indexOf('//') === 0 ? 'https:' + url : url;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function variantText(item) {
    return (item.options_with_values || [])
      .filter(function (o) { return !(o.name === 'Title' && o.value === 'Default Title'); })
      .map(function (o) { return o.name + ': ' + o.value; })
      .join(', ');
  }

  function visibleProperties(item) {
    var props = item.properties || {};
    return Object.keys(props)
      .filter(function (k) { return k.charAt(0) !== '_' && props[k] != null && String(props[k]) !== ''; })
      .map(function (k) { return [k, String(props[k])]; });
  }

  root.PuvanoCartLogic = {
    computeRewards: computeRewards,
    rewardsMessage: rewardsMessage,
    mergeRecommendations: mergeRecommendations,
    pickVariant: pickVariant,
    groupDiscounts: groupDiscounts,
    formatMoney: formatMoney,
    esc: esc,
    sizedImage: sizedImage,
    variantText: variantText,
    visibleProperties: visibleProperties
  };
})(typeof window !== 'undefined' ? window : globalThis);
